import { GlobalState } from '@leverege/ui-redux';
import { Constants } from '@leverege/api-redux';
import { Attributes, DataSources } from '@leverege/ui-attributes';
import Groupings from "../../groupings/Groupings.js";
import RequestUtil from "./RequestUtil.js";
export default class RelationshipValueSource {
  constructor(model) {
    this.model = model;
  }
  async getValues(objRef, grouping, context) {
    const {
      path,
      nameAttribute,
      abbreviationAttribute,
      sortAttribute,
      select
    } = this.model;
    let delegate = DataSources.getActions(objRef);
    // This only goes one level deep
    delegate = delegate?.child(path);
    if (delegate) {
      delegate.queryName = 'grouping'; // Use unique query name to avoid using search options
      try {
        const rtn = [];
        const type = delegate.relationship.objectType;
        const cached = delegate.getList();
        const load = cached === null; // || Date.now() - cached.time > 30000 
        const result = load ? await GlobalState.dispatch(delegate.list({
          perPage: 1000
        })) : cached;
        const {
          items
        } = result;
        let setSelected = true;
        for (let n = 0; n < items.length; n++) {
          const item = items[n];
          let v = {
            id: item.id,
            value: item.id,
            name: item.name
          };
          if (nameAttribute) {
            v.name = Attributes.get(nameAttribute, type, item);
          }
          if (abbreviationAttribute) {
            v.abbreviation = Attributes.get(abbreviationAttribute, type, item);
          }
          if (sortAttribute) {
            v.sort = Attributes.get(sortAttribute, type, item);
          }
          if (item.metadata?.groupingValue) {
            v = {
              ...v,
              ...item.metadata.groupingValue
            };
          }
          if (v.select) {
            setSelected = false;
          }
          rtn.push(v);
        }
        if (sortAttribute) {
          rtn.sort(RequestUtil.sortValues);
        }
        if (rtn.length > 0 && setSelected) {
          if (select === 'first') {
            rtn[0].select = true;
          } else if (select === 'last') {
            rtn[rtn.length - 1].select = true;
          }
        }
        return rtn;
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    }
    return [];
  }
  getUpdater(objRef, grouping, context) {
    const {
      path
    } = this.model;
    let delegate = DataSources.getActions(objRef);
    delegate = delegate?.child(path);
    if (delegate == null) {
      return null;
    }
    return this.createUpdater(delegate.getInterfaceUrl());
  }
  createUpdater(interfacePath) {
    return callback => {
      // We are going to trigger an update on any change to the current list or any
      // change under a relationship value source
      const cb = action => {
        if (action.type === Constants.INTERFACE_REMOVE || action.type === Constants.INTERFACE_UPDATE) {
          if (action.parentPath === interfacePath) {
            callback();
          }
        } else if (action.path === interfacePath) {
          callback();
        }
      };
      return Groupings.addUpdateListener([Constants.INTERFACE_UPDATE, Constants.INTERFACE_CREATE_ADD, Constants.INTERFACE_CREATE_SET, Constants.INTERFACE_REMOVE], cb);
    };
  }
  needsUpdating(objRef, grouping, context) {
    // This is hard to know, as there is no internal indicator
    // against 'grouping' query name other than the call above
    return false;
  }
  static createPlugin() {
    return {
      type: 'relationship',
      valueSource: RelationshipValueSource
    };
  }
}